const mapboxgl = window.mapboxgl
export default class BBox {
    constructor(map, callback) {
        this.map = map;
        this.callback = callback;
        this.editFlag = false;
        this.init()

        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseMove = this.onMouseMove.bind(this)
        this.onMouseUp = this.onMouseUp.bind(this)
    }

    init() {
        this.geojson = {
            'type': 'FeatureCollection',
            'features': []
        }

        this.map.addSource('bbox-geojson', {
            'type': 'geojson',
            'data': this.geojson
        })
        this.map.addLayer({
            id: 'bbox-area',
            type: 'fill',
            source: 'bbox-geojson',
            paint: {
                'fill-color': 'rgba(63,177,206,0.5)'
            },
            filter: ['in', '$type', 'Polygon']
        })
        this.map.addLayer({
            id: 'bbox-point',
            type: 'circle',
            source: 'bbox-geojson',
            paint: {
                'circle-color': '#3fb1ce'
            },
            filter: ['in', '$type', 'Point']
        });

        this.areastring = {
            'type': 'Feature',
            'geometry': {
                'type': 'Polygon',
                'coordinates': []
            },
            'properties': { 'type': 'bbox' }
        }
    }

    start() {
        if (!this.map.getSource('bbox-geojson')) {
            this.init()
        }
        this.map.on('mousedown', this.onMouseDown)
        this.map.on('mousemove', this.onMouseMove)
        this.map.on('mouseup', this.onMouseUp)

        this.startPoint = null
        this.endPoint = null
    }

    onMouseDown(e) {
        if (!this.map.getSource('bbox-geojson')) {
            this.init();
        }
        if (this.editFlag) {
            let bbox = [
                [e.point.x - 5, e.point.y - 5],
                [e.point.x + 5, e.point.y + 5]
            ];
            let features = this.map.queryRenderedFeatures(bbox);
            this.selectPoint = features.find(el => el.layer.type === "circle");
            if (this.selectPoint) {
                this.map.on('mousemove', this.onMouseMove);
                this.map.getCanvasContainer().style.cursor = 'crosshair'
                this.map.dragPan.disable();
            }
        } else {
            if (this.startPoint) return;
            this.map.dragPan.disable();
            this.startPoint = {
                'type': 'Feature',
                'geometry': {
                    'type': 'Point',
                    'coordinates': [e.lngLat.lng, e.lngLat.lat]
                }
            }
        }
    }

    onMouseMove(e) {
        if (this.editFlag) {
            if (this.selectPoint) {
                let type = this.selectPoint.properties.type;
                let point = this.geojson.features.find(el => el.properties.type === type)
                let bbox = this.geojson.features.find(el => el.geometry.type === "Polygon")
                point.geometry.coordinates = [e.lngLat.lng, e.lngLat.lat];
                let coordinates = bbox.geometry.coordinates[0];
                if (type === 'left-top') {
                    coordinates[0][0] = e.lngLat.lng;
                    coordinates[0][1] = e.lngLat.lat;
                    coordinates[1][0] = e.lngLat.lng;
                    coordinates[3][1] = e.lngLat.lat;
                    coordinates[4][0] = e.lngLat.lng;
                    coordinates[4][1] = e.lngLat.lat;
                    let leftBottomPoint = this.geojson.features.find(el => el.properties.type === 'left-bottom');
                    let rightTopPoint = this.geojson.features.find(el => el.properties.type === 'right-top');
                    leftBottomPoint.geometry.coordinates[0] = e.lngLat.lng;
                    rightTopPoint.geometry.coordinates[1] = e.lngLat.lat;
                }
                if (type === 'left-bottom') {
                    coordinates[0][0] = e.lngLat.lng;
                    coordinates[1][0] = e.lngLat.lng;
                    coordinates[1][1] = e.lngLat.lat;
                    coordinates[2][1] = e.lngLat.lat;
                    coordinates[4][0] = e.lngLat.lng;
                    let leftTopPoint = this.geojson.features.find(el => el.properties.type === 'left-top');
                    let rightBottomPoint = this.geojson.features.find(el => el.properties.type === 'right-bottom');
                    leftTopPoint.geometry.coordinates[0] = e.lngLat.lng;
                    rightBottomPoint.geometry.coordinates[1] = e.lngLat.lat;
                }
                if (type === 'right-bottom') {
                    coordinates[1][1] = e.lngLat.lat;
                    coordinates[2][0] = e.lngLat.lng;
                    coordinates[2][1] = e.lngLat.lat;
                    coordinates[3][0] = e.lngLat.lng;
                    let leftBottomPoint = this.geojson.features.find(el => el.properties.type === 'left-bottom');
                    let rightTopPoint = this.geojson.features.find(el => el.properties.type === 'right-top');
                    leftBottomPoint.geometry.coordinates[1] = e.lngLat.lat;
                    rightTopPoint.geometry.coordinates[0] = e.lngLat.lng;
                }
                if (type === 'right-top') {
                    coordinates[0][1] = e.lngLat.lat;
                    coordinates[2][0] = e.lngLat.lng;
                    coordinates[3][0] = e.lngLat.lng;
                    coordinates[3][1] = e.lngLat.lat;
                    coordinates[4][1] = e.lngLat.lat;
                    let leftTopPoint = this.geojson.features.find(el => el.properties.type === 'left-top');
                    let rightBottomPoint = this.geojson.features.find(el => el.properties.type === 'right-bottom');
                    leftTopPoint.geometry.coordinates[1] = e.lngLat.lat;
                    rightBottomPoint.geometry.coordinates[0] = e.lngLat.lng;
                }

                this.map.getSource('bbox-geojson').setData(this.geojson)
                this.areastring = bbox;
                this.callback(this.areastring)
            }
        } else {
            if (!this.floatTipLabel) {
                this.floatTipLabel = this.createLabel(e)
            } else {
                this.floatTipLabel.setLngLat([e.lngLat.lng, e.lngLat.lat])
            }

            if (this.startPoint && this.floatTipLabel) {
                this.floatTipLabel.remove()
            }

            if (!this.floatTipLabel) {
                this.floatTipLabel = this.createLabel(e)
            } else {
                this.floatTipLabel.setLngLat([e.lngLat.lng, e.lngLat.lat])
            }

            let point = {
                'type': 'Feature',
                'geometry': {
                    'type': 'Point',
                    'coordinates': [e.lngLat.lng, e.lngLat.lat]
                }
            }

            if (this.startPoint) {
                this.map.getCanvasContainer().style.cursor = 'crosshair'
                this.endPoint = point

                let array = []
                array.push(this.startPoint.geometry.coordinates)
                array.push([this.startPoint.geometry.coordinates[0], this.endPoint.geometry.coordinates[1]])
                array.push(this.endPoint.geometry.coordinates)
                array.push([this.endPoint.geometry.coordinates[0], this.startPoint.geometry.coordinates[1]])
                array.push(this.startPoint.geometry.coordinates)
                let areastring = this.areastring
                areastring.geometry.coordinates = [array]
                this.geojson.features.push(areastring)

                this.map.getSource('bbox-geojson').setData(this.geojson)

                this.geojson.features.pop()
            }
        }

    }

    onMouseUp(e) {
        if (this.editFlag) {
            this.map.off('mousemove', this.onMouseMove)
            this.map.dragPan.enable()
            this.map.getCanvasContainer().style.cursor = 'default'
        } else {
            if (e.lngLat.lng === this.startPoint.geometry.coordinates[0] && e.lngLat.lat === this.startPoint.geometry.coordinates[1]) {
                this.startPoint = null;
                return;
            }

            let point = {
                'type': 'Feature',
                'geometry': {
                    'type': 'Point',
                    'coordinates': [e.lngLat.lng, e.lngLat.lat]
                }
            }

            if (this.startPoint) {
                this.map.getCanvasContainer().style.cursor = 'default'
                this.endPoint = point;

                let array = []
                array.push(this.startPoint.geometry.coordinates)
                array.push([this.startPoint.geometry.coordinates[0], this.endPoint.geometry.coordinates[1]])
                array.push(this.endPoint.geometry.coordinates)
                array.push([this.endPoint.geometry.coordinates[0], this.startPoint.geometry.coordinates[1]])
                array.push(this.startPoint.geometry.coordinates)
                this.areastring.geometry.coordinates = [array]
                this.geojson.features.push(this.areastring)
                let dictory = {
                    0: "left-top",
                    1: "left-bottom",
                    2: "right-bottom",
                    3: "right-top"
                }
                for (let i = 0; i < 4; i++) {
                    let point = {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': array[i]
                        },
                        'properties': { 'type': dictory[i] }
                    }
                    this.geojson.features.push(point);
                }

                this.map.getSource('bbox-geojson').setData(this.geojson)
            }
            this.editFlag = true;
            this.map.dragPan.enable()
            this.callback(this.areastring)
        }
    }

    updateBBoxPolygon(bbox) {
        if (!this.map.getSource('bbox-geojson')) {
            this.init()
        }
        let array = []
        array.push([bbox[0], bbox[3]]);
        array.push([bbox[0], bbox[1]]);
        array.push([bbox[2], bbox[1]]);
        array.push([bbox[2], bbox[3]]);
        array.push([bbox[0], bbox[3]]);
        this.areastring.geometry.coordinates = [array];
        let dictory = {
            0: "left-top",
            1: "left-bottom",
            2: "right-bottom",
            3: "right-top"
        }
        if (this.geojson.features.length) {
            let polygon = this.geojson.features.find(el => el.geometry.type === "Polygon");
            polygon.geometry.coordinates = [array];
            this.geojson.features.forEach(item => {
                for (let key in dictory) {
                    if (item.properties.type === dictory[key]) {
                        item.geometry.coordinates = array[key];
                    }
                }
            })
        } else {
            this.geojson.features.push(this.areastring);
            for (let i = 0; i < 4; i++) {
                let point = {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Point',
                        'coordinates': array[i]
                    },
                    'properties': { 'type': dictory[i] }
                }
                this.geojson.features.push(point);
            }
        }

        this.map.getSource('bbox-geojson').setData(this.geojson)
    }

    updateGeometry(borderType, value) {
        let bbox = this.geojson.features.find(el => el.geometry.type === "Polygon")
        let coordinates = bbox.geometry.coordinates[0];
        let point = this.geojson.features.filter(el => el.properties.type.includes(borderType));
        switch (borderType) {
            case 'left':
                point.forEach(item => {
                    item.geometry.coordinates[0] = Number(value)
                })
                coordinates[0][0] = Number(value)
                coordinates[1][0] = Number(value)
                coordinates[4][0] = Number(value)
                break
            case 'bottom':
                point.forEach(item => {
                    item.geometry.coordinates[1] = Number(value)
                })
                coordinates[1][1] = Number(value)
                coordinates[2][1] = Number(value)
                break
            case 'right':
                point.forEach(item => {
                    item.geometry.coordinates[0] = Number(value)
                })
                coordinates[2][0] = Number(value)
                coordinates[3][0] = Number(value)
                break
            case 'top':
                point.forEach(item => {
                    item.geometry.coordinates[1] = Number(value)
                })
                coordinates[0][1] = Number(value)
                coordinates[3][1] = Number(value)
                coordinates[4][1] = Number(value)
                break
        }
        this.map.getSource('bbox-geojson').setData(this.geojson)
    }

    createLabel(e) {
        let element = document.createElement('div')
        element.style = 'width:300px;height:20px;font-size:16px;color:#ffffff'
        element.innerHTML = '鼠标按下开始绘制框选区域'
        let marker = new mapboxgl.Marker(element, { offset: [160, 0] })
        marker.setLngLat([e.lngLat.lng, e.lngLat.lat])
        marker.addTo(this.map);
        return marker
    }

    stop() {
        this.map.dragPan.enable()
        if (this.floatTipLabel) {
            this.floatTipLabel.remove()
            this.floatTipLabel = null
        }

        this.map.off('mousedown', this.onMouseDown)
        this.map.off('mousemove', this.onMouseMove)
        this.map.off('mouseup', this.onMouseUp)
    }

    reset() {
        this.stop();
        this.editFlag = false;
        this.selectPoint = null;
        this.geojson.features = [];
        if (this.map.getSource('bbox-geojson')) {
            this.map.getSource('bbox-geojson').setData(this.geojson);
        }
    }

    uninstall() {
        this.stop()

        this.startPoint = null;
        this.endPoint = null;
        this.selectPoint = null;

        this.geojson.features = [];
        if (this.map.getSource('bbox-geojson')) {
            this.map.getSource('bbox-geojson').setData(this.geojson)
        }

        if (this.map.getLayer('bbox-area')) {
            this.map.removeLayer('bbox-area')
        }
        if (this.map.getLayer('bbox-point')) {
            this.map.removeLayer('bbox-point')
        }
        if (this.map.getSource('bbox-geojson')) {
            this.map.removeSource('bbox-geojson')
        }
    }
}